import React, { useEffect } from "react"; // Import the React library and useEffect hook
import HeaderJOHN from "./components/header-components/HeaderJD"; // Import the custom HeaderJOHN component
import FooterJOHN from "./components/footer-components/FooterJD"; // Import the custom FooterJOHN component
import MainContentContactUs from "./components/main-content-components/MainContentContactUs"; // Import the MainContentContactUs component
import { ThemeProvider } from "@deere/fuel-react"; // Import ThemeProvider from Deere's UI library
import { Box } from "@mui/material";

// Define the main App component
function App() {
    // Use useEffect to manipulate the DOM after the component has mounted
    useEffect(() => {
      // Select the link with the class 'Header-link' and change its href attribute
      const headerLink = document.querySelector('.Header-link');
      if (headerLink) {
        headerLink.href = "https://www.deere.com/en/";
      }
    }, []); // Empty dependency array means this effect runs once after initial mount
    
    return (
      // Wrap the application in the ThemeProvider for consistent theming
      <ThemeProvider>
        <Box display="flex" flexDirection="column" minHeight="100vh">
          {/* Render the header component */}
          <HeaderJOHN />
          {/* Render the main content for the Contact Us page */}
          <MainContentContactUs />
          {/* Render the footer component */}
          <FooterJOHN />
        </Box>
      </ThemeProvider>
    );
  }

// Export the App component as the default export
export default App;
